var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.job.customer
        ? _c("div", { staticClass: "customer-info mt-5" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12 avatar-row" }, [
                _c("img", {
                  staticClass: "customer-avatar",
                  attrs: { src: "/static/img/avatar.1d88924.png" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "customer-fullName" }, [
                  _vm._v(
                    _vm._s(_vm.job.customer.first_name) +
                      " " +
                      _vm._s(_vm.job.customer.last_name)
                  )
                ]),
                _vm._v(" "),
                _vm.job.customer.contacts && _vm.job.customer.contacts.length
                  ? _c("span", { staticClass: "customer-contacts" }, [
                      _vm._v("+" + _vm._s(_vm.job.customer.contacts.length))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 mail-row" }, [
                _c("p", [
                  _c("span", {
                    staticClass: "mod-contact-icon mod-icon-email",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(" " + _vm._s(_vm.job.customer.email))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 number-row" }, [
                _c("p", [
                  _c("span", {
                    staticClass: "mod-contact-icon mod-icon-phone",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.phoneMask.maskedPhone(_vm.job.customer.phone))
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.job.customer.customer_cards
                ? _c(
                    "div",
                    { staticClass: "col-md-12 card-row" },
                    _vm._l(_vm.job.customer.customer_cards, function(card) {
                      return _c("div", { key: card.id }, [
                        card.is_default == 1
                          ? _c("span", [
                              _c("span", {
                                staticClass: "mod-card-icon mod-icon-cc",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(
                                " **** **** **** " + _vm._s(card.card_number)
                              )
                            ])
                          : _vm._e()
                      ])
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 text-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button-edit",
                    on: {
                      click: function($event) {
                        _vm.$emit("openM", "open modal")
                      }
                    }
                  },
                  [_vm._m(0), _vm._v(" Edit info")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 text-center send-btn-row" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button-send flex",
                    on: { click: _vm.toggleSidebar }
                  },
                  [_vm._m(1), _vm._v(" Send Email")]
                )
              ])
            ])
          ])
        : _c(
            "div",
            {
              staticClass: "p-3",
              staticStyle: { "background-color": "#f8d7d9" }
            },
            [_vm._m(2)]
          ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCreateSidebar
          ? _c(
              "div",
              { staticClass: "l-modal-mask" },
              [
                _c("send-claim-email", {
                  staticClass: "sidebar-right",
                  attrs: { job: _vm.job, "type-id": 1 },
                  on: {
                    cancel: function($event) {
                      _vm.toggleSidebar()
                    },
                    update: function($event) {
                      _vm.$emit("update")
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.job
        ? _c(
            "vue-content-loading",
            [
              _c("circle", { attrs: { cx: "30", cy: "30", r: "30" } }),
              _vm._v(" "),
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-wrapper" }, [
      _c("span", { staticClass: "fa fa-pencil pointer edit-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass:
          "icon-wrapper flex align-items-center justify-content-center"
      },
      [_c("span", { staticClass: "send-icon fa fa-envelope" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", [_vm._v("Deleted "), _c("br"), _vm._v(" Customer")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47470754", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47470754","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customers/CustomerInfo.vue
// module id = null
// module chunks = 